// How to Use

/* 
  <slick-slider class="its__slideshow" 
    data-autoplay="Boolean"
    data-autoplay-speed="Number"
    data-dots="Boolean"
    data-fade="Boolean"
    data-css-ease="String"
    data-arrows="Boolean">
    ... 
      Slides 
    ...
  </slick-slider>
*/

class slickSlider extends HTMLElement {
  constructor() {
    super();
    this.autoplay = Boolean(this.dataset.autoplay) || false;
    this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 3000;
    this.arrows = Boolean(this.dataset.arrows) || false;
    this.dots = Boolean(this.dataset.dots) || false;
    this.fade = Boolean(this.dataset.dots) || false;
    this.cssEase = this.dataset.cssEase || 'linear';


    this.initSlider();
  }

  initSlider() {
    // We need to be adding more options here as we need them with defaults
    $(this).slick({ 
      dots: this.dots,
      autoplay: this.autoplay,
      fade: this.fade,
      cssEase: this.cssEase,
      autoplaySpeed: this.autoplaySpeed,
      arrows: this.arrows
    });
  }
}

customElements.define("slick-slider", slickSlider);
